import { render, staticRenderFns } from "./Attachments.component.vue?vue&type=template&id=869e0564&scoped=true"
import script from "./Attachments.component.vue?vue&type=script&lang=js"
export * from "./Attachments.component.vue?vue&type=script&lang=js"
import style0 from "./Attachments.component.vue?vue&type=style&index=0&id=869e0564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e0564",
  null
  
)

export default component.exports